import * as React from 'react';
import { connect } from 'react-redux';
import { loadCasesCCD } from '@telstra-connect/channel-care/methods/load-cases-int';
import { IChannelCareAppState } from '@telstra-connect/channel-care/state';
import { ICase, ILoadCasesCCDRequest } from '@telstra-connect/channel-care/state/cases-int';
import { AsyncActions } from '@telstra-connect/standard-actions';
import { InlineSpinner } from '@components/spinner/inline-spinner';
import './style.less';
import { Table } from 'telstra-ui/components/table/Table';
import { columnsData, renderTableInt } from './cases-int-table'
import { EmptyEnquiries } from '@components/empty-enquiries/empty-enquiries';
import { ErrorServer } from '@components/error-server/error-server';
import { IWithRouterProps, navigateType, withRouter } from '@utils/withRouterWrapper';

interface IListCasesOwnProps {
    unifiedTrackView?: boolean;
    tabName?: string;
    activeTab?: string
    onTryAgain?: () => void
    cidn?: string;
}
interface IListCasesStateProps {
    casesInt: ILoadCasesCCDRequest;
}

interface IListCasesDispatchProps {
    loadCasesCCD: (type: string, cidn: string) => void;
}

type ListCasesProps =
    IListCasesOwnProps &
    IListCasesStateProps &
    IListCasesDispatchProps;

const ListComponnetWrap = ({ children }) => {
    return (
        <div className=" int-ccd-enquiry-table">{children}</div>
    );
}

interface ICaseProps {
    cases: ICase[]
    trackView: boolean;
    loadingStatus: AsyncActions.AsyncActionState
    onTryAgain?: () => void
    tabName?: string
    cidn?: string
    navigate: navigateType
}
const renderCategory = {
    'Order enquiry': 'Order_Enquiry',
    'Billing enquiry': 'Billing_Enquiry'
}

const CaseBody = ({
    cases = [],
    trackView,
    loadingStatus,
    onTryAgain,
    tabName,
    cidn,
    navigate
}: ICaseProps) => {
    if (loadingStatus === AsyncActions.AsyncActionState.Initiated) {
        return (
            <ListComponnetWrap>
                <Table
                    data={[]}
                    columns={columnsData}
                    resizable={true}
                    sortable={true}
                    showPagination={false}
                    defaultPageSize={20}
                />
                <div className="visible-xs cc-hspacer-32 " />
                <div className="row cc-inline-spinner-wrap ccd-table-spinner-int">
                    <InlineSpinner />
                </div>
            </ListComponnetWrap>
        );
    }

    return (
        <div>
            {
                (
                    loadingStatus === AsyncActions.AsyncActionState.Success
                    && cases.length > 0
                    &&
                    <React.Fragment>
                        {renderTableInt(cases, tabName, navigate)}
                    </React.Fragment>
                )
                ||
                (
                    <React.Fragment>
                        <Table
                            data={[]}
                            columns={columnsData}
                            resizable={true}
                            sortable={true}
                            showPagination={false}
                            defaultPageSize={20}
                        />
                        {loadingStatus === AsyncActions.AsyncActionState.Failure &&
                            <div >
                                <ErrorServer onTryAgain={onTryAgain} />
                            </div>}
                        {
                            loadingStatus === AsyncActions.AsyncActionState.Success &&
                            cases.length === 0 &&
                            <div >
                                <EmptyEnquiries
                                    category={renderCategory[tabName]}
                                    cidn={cidn}
                                    navigate={navigate} />
                            </div>}

                    </React.Fragment>
                )
                ||
                null
            }
        </div>
    );
}

type ListCasesCombinedProps = ListCasesProps & IWithRouterProps;

class ListCasesComponent extends React.Component<ListCasesCombinedProps, {}> {
    constructor(props: ListCasesCombinedProps) {
        super(props);
    }

    public componentDidMount() {
        this.triggerRefresh();

    }

    public render() {
        const { status: loadingStatus, data: { cases } } = this.props.casesInt;
        return (
            <ListComponnetWrap>
                <CaseBody trackView={this.props.unifiedTrackView}
                    cases={cases}
                    loadingStatus={loadingStatus}
                    onTryAgain={this.triggerRefresh}
                    tabName={this.props.tabName}
                    cidn={this.props.cidn}
                    navigate={this.props.navigate}
                />
            </ListComponnetWrap>
        );
    }

    private triggerRefresh = () => {
        this.props.loadCasesCCD(this.props.activeTab, this.props.cidn);
    }
};

type SubscribedState = IChannelCareAppState

const mapStateToProps = (state: SubscribedState): IListCasesStateProps => {
    return {
        casesInt: state.channelCare.casesInt,
    };
};

const mapDispatchToProps = (dispatch): IListCasesDispatchProps => {
    return {
        loadCasesCCD: (type: string, cidn: string) => dispatch(loadCasesCCD(type, cidn)),
    };
};

export const ListCasesInt = withRouter(connect<IListCasesStateProps, IListCasesDispatchProps, IListCasesOwnProps & IWithRouterProps, SubscribedState>
(mapStateToProps, mapDispatchToProps)(ListCasesComponent));
